import { useEffect, useState } from 'react';

export const useDelay = (time = 0) => {
    const [showAfterDelay, setShowAfterDelay] = useState(time === 0);

    useEffect(() => {
        if (time > 0) {
            const timer = setTimeout(
                () => setShowAfterDelay(true),
                time * 1000
            );

            return () => timer && clearTimeout(timer);
        }

        return () => null;
    }, [time]);

    return {
        showAfterDelay
    };
};

export default useDelay;
